module.exports = __webpack_public_path__ + "861afb4434238e34ca64e61485a722d7.png";